<div [style.display]="isVisible() ? 'flex' : 'none'" class="item-container time-input-container">
  <label
    [for]="htmlId()"
    [ngClass]="[properties.style.toLowerCase(), 'preserve-newlines']"
    [style]="getCaptionStyle()"
    [title]="getCaptionTitle()">
    {{ properties.text }}
  </label>
  <div class="second-column input-container">
    <input
      [id]="htmlId()"
      [type]="properties.inputType"
      [formControl]="formControl!"
      [style]="inputStyle()"
      [ngClass]="inputClass()"
      (change)="onTimeChange($event)"
      step="1" />

    <button
      type="button"
      class="now-button"
      [disabled]="formControl?.disabled"
      (click)="onSetNowClick($event)"
      [title]="translateService.instant('liveforms-editor.time-input-item.tooltips.set-now')">
      {{ translateService.instant('liveforms-editor.time-input-item.buttons.now') }}
    </button>

    <button
      type="button"
      class="clear-button"
      (click)="onClearTimeClick($event)"
      [disabled]="formControl?.disabled || !formControl?.value"
      [title]="translateService.instant('liveforms-editor.time-input-item.tooltips.clear')">
      <div class="icon-safe-zone">
        <mat-icon class="icon">delete</mat-icon>
      </div>
    </button>
  </div>
</div>
